module.exports = __webpack_public_path__ + "img/codingTest.bc0dc51c.svg";